import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dashboardComponent from './dashboard.component';

let dashboardModule = angular.module('dashboard', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard', {
    url: '/main',
    component: 'dashboard'
  });
})

.component('dashboard', dashboardComponent)

.name;

export default dashboardModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.js